import { countries } from "../../../Constants/countries";

export const variantProductFieldDetails = [
  {
    id: "price",
    title: "MRP",
    placeholder: "MRP",
    type: "number",
    required: true,
    valueInDecimal: true,
  },
  {
    id: "sellingPrice",
    title: "Selling Price",
    placeholder: "Selling Price",
    type: "number",
    required: true,
    valueInDecimal: true,
  },
  {
    id: "uomValue",
    title: "UOM value",
    placeholder: "UOM value",
    type: "input",
    required: true,
    maxLength: 10,
  },
  {
    id: "uom",
    title: "UOM",
    placeholder: "UOM",
    type: "select",
    required: true,
    options: [
      { key: "unit", value: "UNIT" },
      { key: "dozen", value: "DOZEN" },
      { key: "gram", value: "GRAM" },
      { key: "pieces", value: "PIECES" },
      { key: "kilogram", value: "KILOGRAM" },
      { key: "tonne", value: "TONNE" },
      { key: "litre", value: "LITRE" },
      { key: "millilitre", value: "MILLILITRE" },
    ],
  },
  {
    id: "availableQty",
    title: "Quantity",
    placeholder: "Quantity",
    type: "number",
    maxLength: 10,
    required: true,
  },
  {
    id: "sku",
    title: "SKU",
    placeholder: "SKU",
    type: "input",
    maxLength: 50,
    required: true,
    isDisabled: true,
  },
  {
    id: "imageUrls",
    title: "Images (Select minimum 1 files with maximum size of 2Mb for each file)",
    type: "upload",
    multiple: true,
    file_type: "product_image",
    required: true,
  },
  {
    id: "backImage",
    title: "Product Thumbnail",
    type: "upload",
    file_type: "product_image",
    required: false,
  }
]

export const allProductFieldDetails = [
  {
    id: "subCategory",
    title: "Sub Category",
    placeholder: "Sub Category",
    type: "input",
    required: true,
    isDisabled: true
  },
  {
    id: "productName",
    title: "Product Name",
    placeholder: "Product Name",
    type: "input",
    required: true,
  },
  {
    id: "price",
    title: "MRP",
    placeholder: "MRP",
    type: "number",
    required: true,
    valueInDecimal: true,
  },
  {
    id: "sellingPrice",
    title: "Selling Price",
    placeholder: "Selling Price",
    type: "number",
    required: true,
    valueInDecimal: true,
  },
  {
    id: "gstPercentage",
    title: "GST Percentage",
    placeholder: "Please Select GST Percentage",
    type: "select",
    options: [
      { key: "0", value: "0" },
      { key: "5", value: "5" },
      { key: "12", value: "12" },
      { key: "18", value: "18" },
      { key: "28", value: "28" },
    ],
    required: true,
  },
  {
    id: "availableQty",
    title: "Quantity",
    placeholder: "Quantity",
    type: "number",
    maxLength: 10,
    required: true,
  },
  {
    id: "minAllowedQty",
    title: "Min Allowed Quantity",
    placeholder: "Min Allowed Quantity",
    type: "number",
    required: true,
    min: 1,
    maxLength: 10,
  },
  {
    id: "maxAllowedQty",
    title: "Max Allowed Quantity",
    placeholder: "Max Allowed Quantity",
    type: "number",
    required: true,
    min: 1,
    maxLength: 10,
  },
  {
    id: "uom",
    title: "UOM",
    placeholder: "UOM",
    type: "select",
    required: true,
    options: [
      { key: "unit", value: "UNIT" },
      { key: "dozen", value: "DOZEN" },
      { key: "gram", value: "GRAM" },
      { key: "pieces", value: "PIECES" },
      { key: "kilogram", value: "KILOGRAM" },
      { key: "tonne", value: "TONNE" },
      { key: "litre", value: "LITRE" },
      { key: "millilitre", value: "MILLILITRE" },
    ],
  },
  {
    id: "uomValue",
    title: "UOM value",
    placeholder: "UOM value",
    type: "input",
    required: true,
    maxLength: 10,
  },
  {
    id: "longDescription",
    title: "Description",
    placeholder: "Description",
    type: "input",
    required: true,
    multiline: true,
  },
  {
    id: "fulfillmentOption",
    title: "Fulfilment Option",
    placeholder: "Available Fulfillment Options",
    type: "input",
    required: true,
    isDisabled: true,
  },
  {
    id: "countryOfOrigin",
    title: "Country Of Origin",
    placeholder: "Country Of Origin",
    type: "select",
    options: countries,
    required: true,
  },
  {
    id: "vegNonVeg",
    title: "Veg/Non-Veg/Egg",
    placeholder: "Select Food Category",
    type: "select",
    options: [
      { key: "Veg", value: "VEG" },
      { key: "Non Veg", value: "NONVEG" },
      { key: "Egg", value: "EGG" },
    ],
    disableClearable: true,
    required: true,
  },
  {
    id: "sku",
    title: "SKU",
    placeholder: "SKU",
    type: "input",
    maxLength: 50,
    required: true,
    isDisabled: true,
  },
  {
    id: "productCode",
    title: "Product Code (EAN / ISBN / GTIN / HSN / Others)",
    placeholder: "Product Code",
    type: "input",
    required: true,
    isDisabled: false,
  },
  {
    id: "brandOwnerFssaiLicenseNo",
    title: "FSSAI License No",
    placeholder: "FSSAI License No",
    type: "number",
    maxLength: 14,
    required: false,
    isDisabled: false,
  },
  {
    id: "manufacturerName",
    title: "Manufacturer Name",
    placeholder: "Manufacturer Name",
    type: "input",
    maxLength: 255,
    required: false,
  },
  {
    id: "manufacturerAddress",
    title: "Manufacturer Address",
    placeholder: "Manufacturer Address",
    type: "input",
    required: false,
  },
  {
    id: "nutritionalInfo",
    title: "Nutritional Info",
    placeholder: "Nutritional Info",
    type: "input",
    required: false,
  },
  {
    id: "additiveInfo",
    title: "Additive Info",
    placeholder: "Additive Info",
    type: "input",
    required: false,
  },
  {
    id: "instructions",
    title: "Instructions",
    placeholder: "Instructions",
    type: "input",
    required: false,
  },
  {
    id: "ingredientsInfo",
    title: "Ingredients",
    placeholder: "Ingredients",
    type: "input",
    required: false,
    multiline: true,
  },
  {
    id: "imageUrls",
    title: "Images (Select minimum 1 files with maximum size of 2Mb for each file)",
    type: "upload",
    multiple: true,
    file_type: "product_image",
    required: true,
  },
  {
    id: "backImage",
    title: "Product Thumbnail",
    type: "upload",
    file_type: "product_image",
    required: false,
  },
];

export const categorySpecificFields = {
  "RET10": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "vegNonVeg", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "nutritionalInfo", "additiveInfo", "instructions", "ingredientsInfo", "imageUrls", "backImage"],
  "RET12": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "instructions", "imageUrls", "backImage"],
  "RET13": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "instructions", "imageUrls", "backImage"],
  "RET14": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "instructions", "imageUrls", "backImage"],
  "RET15": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "instructions", "imageUrls", "backImage"],
  "RET16": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "instructions", "imageUrls", "backImage"],
  "RET18": ["subCategory", "productName", "price", "sellingPrice", "gstPercentage", "availableQty", "minAllowedQty", "maxAllowedQty", "uom", "uomValue", "longDescription", "fulfillmentOption", "countryOfOrigin", "sku", "productCode", "brandOwnerFssaiLicenseNo", "manufacturerName", "manufacturerAddress", "instructions", "imageUrls", "backImage"],
};